var $38a82c7bd4f266a1$exports = {};
$38a82c7bd4f266a1$exports = {
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`
};


export {$38a82c7bd4f266a1$exports as default};
//# sourceMappingURL=he-IL.mjs.map
